import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button, Card, CardBody, CardTitle, CardText } from 'reactstrap';

const ProfilePage = () => {
    const [user, setUser] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        getUserData();
    }, []);

    const handleLogout = async () => {
        try {
            const response = await fetch('/auth/session/signout', {
                method: 'POST', // Or 'POST', based upon your endpoint
                credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json' },
            });

            if (response.ok) {
                // Assuming your API returns user data on successful login                
                window.location.href = '/login';
                console.log("Logout Success");
            }
            console.error("Logout failed. Status:", response.status);
        } catch (error) {
            console.error('Failed to check login status', error);
        }
    };
    const getUserData = async () => {
        try {
            setIsLoading(true);
            const response = await fetch(`profile/dax`);
            if (response.ok) {
                const data = await response.json();
                setUser(data.userClaims);
                setIsLoading(false);
            }
            
        } catch (error) {
            console.error(`Error loading user data: ${error}`);
        }
    };

    if (isLoading) {
        return <div className= "text-center"><img src="https://spagblob.blob.core.windows.net/odin-image/Loading.gif" alt="loading" style={{ opacity: '50%', padding: '80px 0px 80px 0px' }} /></div>;
    }
    return (
        <Container className="mt-5">
            <Row className="justify-content-center">
                {/* Profile Header */}
                <Col md="8" className="text-center mt-5">
                    <Card className="p-3 mb-3">
                        <Row className="align-items-center justify-content-center">
                            <Col md="9" className="text-md-left">
                                <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
                                    <img
                                        src="grabprofile.jpeg"  // Replace this with user.profileImage or your image URL
                                        alt="Profile"
                                        style={{
                                            width: '150px',
                                            height: '150px',
                                            borderRadius: '50%',
                                            objectFit: 'cover',
                                            border: '2px solid #ddd'
                                        }}
                                    />
                                </div>
                                <CardTitle tag="h2">{user.driverName}</CardTitle>
                                <CardText>Email: {user.driverEmail}</CardText>
                                <CardText>Phone: +{user.driverPhone}</CardText>
                                <CardText>Country Code: {user.driverCC}</CardText>
                                <CardText>Activated: {
                                    user.driverIsActived === "1" ?
                                        <i className="fas fa-check-circle" style={{ color: '#0a9830' }}></i> :
                                        <i className="fa fa-times-circle" style={{ color: 'red' }}></i>
                                }</CardText>
                                <div className="mt-2">
                                    <Button color="secondary" onClick={handleLogout}>Log Out</Button>
                                </div>
                            </Col>
                        </Row>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default ProfilePage;
